'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateFns = require('date-fns');

var _isobject = require('isobject');

var _isobject2 = _interopRequireDefault(_isobject);

var _DatePicker = require('../DatePicker/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _TimePicker = require('../TimePicker/TimePicker');

var _TimePicker2 = _interopRequireDefault(_TimePicker);

var _Container = require('./components/Container.DateTimePicker');

var _Container2 = _interopRequireDefault(_Container);

var _notifyIfDisabled = require('../lib/notifyIfDisabled.date');

var _notifyIfDisabled2 = _interopRequireDefault(_notifyIfDisabled);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Libs


var DateTimePicker = function (_Component) {
  _inherits(DateTimePicker, _Component);

  function DateTimePicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateTimePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateTimePicker.__proto__ || Object.getPrototypeOf(DateTimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.stringDate = function (date, time) {
      return (0, _dateFns.format)((0, _dateFns.parse)(date + 'T' + time), 'YYYY-MM-DDTHH:mm:ssZ');
    }, _this.onChange = function (date, time) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabledDates = _this$props.disabledDates;

      var stringDate = _this.stringDate(date, time);

      if ((0, _notifyIfDisabled2.default)(stringDate, disabledDates)) return;
      onChange(stringDate);
    }, _this.getDateTime = function () {
      var value = _this.props.value;
      var def = {
        date: null,
        time: null
      };
      if (!value) return def;
      var datetime = (0, _dateFns.parse)(value);
      if (!(0, _dateFns.isDate)(datetime)) return def;
      return {
        date: (0, _dateFns.format)(datetime, 'YYYY-MM-DD'),
        time: (0, _dateFns.format)(datetime, 'HH:mm:ss')
      };
    }, _this.setDate = function (date) {
      var _this$props2 = _this.props,
          disabledDates = _this$props2.disabledDates,
          step = _this$props2.step;

      var _this$getDateTime = _this.getDateTime(),
          time = _this$getDateTime.time;

      var actualTime = time || (0, _dateFns.format)((0, _dateFns.startOfHour)(new Date()), 'HH:mm:ss');

      if ((0, _notifyIfDisabled2.default)(_this.stringDate(date, actualTime), disabledDates, false)) {
        var sameDay = disabledDates.find(function (dd) {
          return (0, _isobject2.default)(dd) && !!dd.before && (0, _dateFns.isSameDay)(date, dd.before);
        });

        if (!!sameDay) {
          var afterStep = (0, _dateFns.addMinutes)(sameDay.before, step);
          var newDate = (0, _dateFns.format)(afterStep, 'YYYY-MM-DD');
          var newTime = (0, _dateFns.format)(afterStep, 'HH:mm:ss');
          return _this.onChange(newDate, newTime);
        }
      }

      _this.onChange(date, actualTime);
    }, _this.setTime = function (time) {
      var _this$getDateTime2 = _this.getDateTime(),
          date = _this$getDateTime2.date;

      var actualDate = date || (0, _dateFns.format)(new Date(), 'YYYY-MM-DD');

      _this.onChange(actualDate, time);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateTimePicker, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabledDates = _props.disabledDates,
          inline = _props.inline,
          step = _props.step;

      var _getDateTime = this.getDateTime(),
          date = _getDateTime.date,
          time = _getDateTime.time;

      return _react2.default.createElement(_Container2.default, {
        inline: inline
      }, _react2.default.createElement(_DatePicker2.default, {
        value: date,
        onChange: this.setDate,
        disabledDates: disabledDates,
        inline: true,
        skipDisabledCheck: true
      }), _react2.default.createElement(_TimePicker2.default, {
        value: time,
        onChange: this.setTime,
        disabledDates: disabledDates,
        date: date,
        step: step,
        inline: true,
        short: true
      }));
    }
  }]);

  return DateTimePicker;
}(_react.Component);

DateTimePicker.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  disabledDates: _propTypes2.default.array,
  inline: _propTypes2.default.bool,
  step: _propTypes2.default.number
};
DateTimePicker.defaultProps = {
  disabledDates: [],
  inline: false,
  step: 15
};
exports.default = DateTimePicker;